import {Page} from "@indebted/components/Page"
import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {Prop, PropLabel, Props, PropValue} from "@indebted/components/Props"
import {useTranslation} from "react-i18next"

import {useStatusPageData} from "./index"

export function AutomaticallyCancelledPage() {
	const data = useStatusPageData()
	const {t, i18n} = useTranslation()
	const {InstalmentAmountValue, InstalmentAmountCurrency, FrequencyValue, ClientName, CustomerName, StartDateValue} =
		data.data
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{t("payment_arrangement_status.automatically_cancelled.title")}
				</Typography>
			</Grid>

			<Grid>
				<Typography className="amp-mask">
					{t("payment_arrangement_status.automatically_cancelled.message", {
						CustomerName: CustomerName,
					})}
				</Typography>
			</Grid>

			<Grid>
				<Typography>{t("payment_arrangement_status.automatically_cancelled.details.title")}</Typography>
			</Grid>
			<Props>
				<Prop>
					<PropLabel align="right">
						{t("payment_arrangement_status.automatically_cancelled.details.plan.label")}
					</PropLabel>
					<PropValue align="left">
						{t(`payment_arrangement_status.automatically_cancelled.details.plan.value.${FrequencyValue}`, {
							InstalmentAmount: InstalmentAmountValue / 100,
							formatParams: {
								InstalmentAmount: {
									currency: InstalmentAmountCurrency,
								},
							},
						})}
					</PropValue>
				</Prop>
				<Prop>
					<PropLabel align="right">
						{t("payment_arrangement_status.automatically_cancelled.details.paid_to.label")}
					</PropLabel>
					<PropValue align="left" className="amp-mask">
						{ClientName}
					</PropValue>
				</Prop>
				<Prop>
					<PropLabel align="right">
						{t("payment_arrangement_status.automatically_cancelled.details.start_date.label")}
					</PropLabel>
					<PropValue align="left">
						{new Date(StartDateValue).toLocaleDateString(i18n.language, {
							year: "numeric",
							month: "long",
							day: "numeric",
						})}
					</PropValue>
				</Prop>
			</Props>
		</Page>
	)
}
